var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPax56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.65 24 24 18.65 24 12C24 5.34996 18.65 0 12 0C5.34996 0 0 5.34996 0 12C0 18.65 5.34996 24 12 24ZM9.29388 17.6887H10.2504C10.4382 17.6887 10.5913 17.7409 10.7095 17.8487C10.8278 17.9565 10.8834 18.1061 10.8834 18.3009C10.8834 18.4678 10.8313 18.6139 10.7269 18.7357C10.6226 18.8609 10.4661 18.92 10.2504 18.92H9.58258V19.8209H9.29388V17.6887ZM10.4139 17.9844C10.3513 17.9531 10.2643 17.9392 10.153 17.9392H9.58258V18.68H10.153C10.2817 18.68 10.3861 18.6522 10.4661 18.5965C10.5461 18.5409 10.5878 18.4435 10.5878 18.3044C10.5878 18.1479 10.5287 18.04 10.4139 17.9844ZM11.9791 17.6887H11.6557L10.8522 19.8244H11.1478L11.3774 19.1844H12.2226L12.4383 19.8244H12.7548L11.9791 17.6887ZM11.8017 18.0087L12.1252 18.9513H11.4574L11.8017 18.0087ZM13.1965 19.8244H12.8487L13.6035 18.7287L12.8939 17.6887H13.2557L13.7948 18.5061L14.3304 17.6887H14.6748L13.9687 18.7287L14.7096 19.8244H14.3513L13.7843 18.9479L13.2 19.8244H13.1965ZM20 9.92522H13.0713H13.0643C13.047 10.0713 13.033 10.2209 13.033 10.3704C13.033 10.4678 13.04 10.5652 13.047 10.6591H19.993V11.153H13.127C13.4852 12.6835 14.8557 13.8278 16.4939 13.8278H18.4939V17.0417H16.5809V15.7409H16.4939C14.6226 15.7409 12.9704 14.7739 12.0104 13.3165C11.0504 14.7739 9.40174 15.7409 7.52696 15.7409H7.44V17.0417H5.52696V13.8278H7.52696C9.16522 13.8278 10.5391 12.6835 10.8939 11.153H4V10.6591H10.9739C10.9809 10.5652 10.9878 10.4678 10.9878 10.3704C10.9878 10.2209 10.9739 10.0713 10.9565 9.92522H4V9.4313H10.8522C10.4417 7.98087 9.10957 6.91304 7.52696 6.91304H5.35652V5H7.53043C9.40174 5 11.0539 5.96696 12.0139 7.42435C12.9739 5.96696 14.6226 5 16.4974 5H18.6678V6.91304H16.4974C14.9148 6.91304 13.5826 7.98087 13.1722 9.4313H20V9.92522Z",
    fill: "url(#paint0_linear_163_700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_700",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B266F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPax56);
export default __webpack_public_path__ + "static/media/pax56.00e7d0f3430415fdf1733ee21225f262.svg";
export { ForwardRef as ReactComponent };